import { SVGFC } from '@repo/toolkit/types'

const LocationTwoIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M11.9991 3.99951C9.23349 3.99951 6.98486 6.27142 6.98486 9.07373C6.98486 10.023 7.40235 11.2006 8.01001 12.3752C9.34789 14.9618 11.5765 17.567 11.5765 17.567C11.6819 17.6905 11.8365 17.7619 11.9991 17.7619C12.1618 17.7619 12.3163 17.6905 12.4218 17.567C12.4218 17.567 14.6504 14.9618 15.9883 12.3752C16.5959 11.2006 17.0134 10.023 17.0134 9.07373C17.0134 6.27142 14.7648 3.99951 11.9991 3.99951ZM11.9991 6.97516C10.8715 6.97516 9.95629 7.89165 9.95629 9.02091C9.95629 10.1502 10.8715 11.0667 11.9991 11.0667C13.1268 11.0667 14.042 10.1502 14.042 9.02091C14.042 7.89165 13.1268 6.97516 11.9991 6.97516Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M15.5538 16.0026C16.1578 16.1842 16.6555 16.4089 16.9994 16.6723C17.2223 16.8419 17.3857 17.0079 17.3857 17.2103C17.3857 17.3293 17.3181 17.4372 17.223 17.5451C17.0655 17.7229 16.8315 17.8829 16.5418 18.0317C15.5182 18.5563 13.8631 18.8844 12 18.8844C10.1369 18.8844 8.48183 18.5563 7.45817 18.0317C7.16846 17.8829 6.93446 17.7229 6.77697 17.5451C6.68189 17.4372 6.61429 17.3293 6.61429 17.2103C6.61429 17.0079 6.77771 16.8419 7.00057 16.6723C7.34451 16.4089 7.84223 16.1842 8.44617 16.0026C8.74034 15.9141 8.90749 15.6023 8.81909 15.3076C8.73069 15.0122 8.41943 14.8448 8.12526 14.9334C7.2056 15.2109 6.49097 15.5911 6.0616 16.0115C5.68423 16.3799 5.5 16.7921 5.5 17.2103C5.5 17.7326 5.79491 18.2535 6.3944 18.688C7.44629 19.45 9.55897 20.0006 12 20.0006C14.441 20.0006 16.5537 19.45 17.6056 18.688C18.2051 18.2535 18.5 17.7326 18.5 17.2103C18.5 16.7921 18.3158 16.3799 17.9384 16.0115C17.509 15.5911 16.7944 15.2109 15.8747 14.9334C15.5806 14.8448 15.2693 15.0122 15.1809 15.3076C15.0925 15.6023 15.2597 15.9141 15.5538 16.0026Z"
      />
    </svg>
  )
}

export default LocationTwoIcon
